import { LE } from "@/constants/enumsNew";
import { getLookupsFromLookupGroup, useLookup } from "@modernary/mui/components/lookup";
import { until } from "@vueuse/core";
import { type RouterOptions } from "vue-router";

const names = {
  // analytics: "Analytics",
  disposedWasteReport: "Analytics.DisposedWasteReport",
  divertedMaterialReport: "Analytics.DivertedMaterialReport",
  generatedWasteReport: "Analytics.GeneratedWasteReport",
  divertedWasteReport: "Analytics.DivertedWasteReport",
  exportDisposalReportData: "Analytics.ExportDisposalReportData",
  exportRecyclingReportData: "Analytics.ExportRecyclingReportData",
  materialCategoryReport: "Analytics.MaterialCategoryReport",
  organizationMaterialReport: "Analytics.OrganizationMaterialReport",
  recycledMaterialReport: "Analytics.RecycledMaterialReport",
  recyclingRateReport: "Analytics.RecyclingRateReport",
  emailList: "Analytics.EmailList",
  exportFacilityData: "Analytics.ExportFacilityData",
};

export { names as analyticsRouteNames };

const analyticsRoutes: RouterOptions["routes"] = [
  {
    path: "/analytics",
    //    name: names.analytics,
    component: () => import("@/views/analytics/AnalyticsBase.vue"),
    redirect: { name: names.divertedMaterialReport },
    children: [
      {
        path: "divertedMaterialReport",
        name: names.divertedMaterialReport,
        meta: { title: "Diverted Material Report" },
        component: () => import("@/views/analytics/DivertedMaterialReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              nevadaCounty: countyLookup,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "generatedWasteReport",
        name: names.generatedWasteReport,
        meta: { title: "Generated Waste Report" },
        component: () => import("@/views/analytics/GeneratedWasteReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const lookups = {
              county: (await getLookupsFromLookupGroup("County"))._items,
              haulerType: (await getLookupsFromLookupGroup("HaulerType"))._items,
              disposalWasteType: (await getLookupsFromLookupGroup("DisposalWasteType"))._items,
              reportPeriod: (await getLookupsFromLookupGroup("ReportPeriod"))._items,
              facilitySiteType: (await getLookupsFromLookupGroup("FacilitySiteType"))._items,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "divertedWasteReport",
        name: names.divertedWasteReport,
        meta: { title: "Diverted Waste Report" },
        component: () => import("@/views/analytics/DivertedWasteReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const lookups = {
              county: (await getLookupsFromLookupGroup("County"))._items,
              haulerType: (await getLookupsFromLookupGroup("HaulerType"))._items,
              reportPeriod: (await getLookupsFromLookupGroup("ReportPeriod"))._items,
              facilitySiteType: (await getLookupsFromLookupGroup("FacilitySiteType"))._items,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" });
          }
        },
      },
      {
        path: "exportRecyclingReportData",
        name: names.exportRecyclingReportData,
        meta: { title: "Recycling Report Data Export", hideFilterChange: true },
        component: () => import("@/views/analytics/ExportRecyclingReportData.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              recyclingReportStatus: (await getLookupsFromLookupGroup("RecyclingReportStatus"))._items,
              nevadaCounty: countyLookup,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "exportDisposalReportData",
        name: names.exportDisposalReportData,
        meta: { title: "Disposal Report Data Export", hideFilterChange: true },
        component: () => import("@/views/analytics/ExportDisposalReportData.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              facilitySiteType: (await getLookupsFromLookupGroup("FacilitySiteType"))._items,
              nevadaCounty: countyLookup,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "materialCategoryReport",
        name: names.materialCategoryReport,
        meta: { title: "Material Category Report" },
        component: () => import("@/views/analytics/MaterialCategoryReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              nevadaCounty: countyLookup,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "organizationMaterialReport",
        name: names.organizationMaterialReport,
        meta: { title: "Organization Material Report" },
        component: () => import("@/views/analytics/OrganizationMaterialReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              nevadaCounty: countyLookup,
              materialCategory: (await getLookupsFromLookupGroup("MaterialCategory"))._items,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },

      {
        path: "recycledMaterialReport",
        name: names.recycledMaterialReport,
        meta: { title: "Recycled Material Report" },
        component: () => import("@/views/analytics/RecycledMaterialReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              nevadaCounty: countyLookup,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "recyclingRateReport",
        name: names.recyclingRateReport,
        meta: { title: "Recycling Rate Report", showPrint: true },
        component: () => import("@/views/analytics/RecyclingRateReport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              nevadaCounty: countyLookup,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "emailList",
        name: names.emailList,
        meta: { title: "Email List Report" },
        component: () => import("@/views/analytics/EmailList.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const lookups = {
              facilitySiteType: (await getLookupsFromLookupGroup("FacilitySiteType"))._items,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
      {
        path: "exportFacilityData",
        name: names.exportFacilityData,
        meta: { title: "Facility Data Export", hideFilterChange: true },
        component: () => import("@/views/analytics/FacilityDataExport.vue"),
        props: (route) => ({
          lookups: route.params.lookups,
        }),
        beforeEnter: async (to, from, next) => {
          try {
            const countyLookup = useLookup("County");
            await countyLookup.loadOptions({ stateMurn: LE.State.NV }, undefined); //prefilter for NV

            const lookups = {
              nevadaCounty: countyLookup,
              facilityPhysicalStatus: (await getLookupsFromLookupGroup("FacilityPhysicalStatus"))._items,
              facilityPermitStatus: (await getLookupsFromLookupGroup("FacilityPermitStatus"))._items,
              facilityType: (await getLookupsFromLookupGroup("FacilitySiteType"))._items,
            };
            to.params.lookups = lookups as any;
            next();
          } catch (error) {
            next({ name: "errorRoute" }); //TODO:
          }
        },
      },
    ],
  },
];
export default analyticsRoutes;
